import { GAME_ID, REDUX_ACTIONS } from 'a/cutItOut/data/constants';

export const initialState = {
  pictureIsDragged: false,
  draggedPictureLabel: null,
  pictureIsDropped: false,
};

const dragAndDropReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_DRAG_AND_DROP:
      return initialState;
    case REDUX_ACTIONS.SET_PICTURE_DRAGGED:
      return {
        ...state,
        pictureIsDragged: true,
        pictureIsDropped: false,
        draggedPictureLabel: action.payload.draggedPictureLabel,
      };
    case REDUX_ACTIONS.SET_PICTURE_DROPPED:
      return {
        ...state,
        pictureIsDropped: true,
        pictureIsDragged: false,
      };
    default:
      return state;
  }
};

export default dragAndDropReducer;
